import { Component, Input, Output, EventEmitter, forwardRef, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, NG_VALUE_ACCESSOR, ControlValueAccessor, NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';
import { FormGroup, FormControl, Validators } from '@angular/forms';
/* Description *
 * Generic Phone Input Component
 * Works with both Reactive Forms and Template-Driven Forms
 *  
 * Features:
 * - Auto-formatting as you type
 * - Country code selection with flags
 * - Built-in validation
 * - Search countries
 * - Multiple format options
 * 
 * Usage:
 * Reactive: <app-phone-input formControlName="phone" [required]="true"></app-phone-input>
 * Template: <app-phone-input [(ngModel)]="phone" name="phone"></app-phone-input>
 */

@Component({
  selector: 'app-glo-phonenumber-input',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxIntlTelInputModule

  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GloPhonenumberInputComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => GloPhonenumberInputComponent),
      multi: true
    }
  ],

  templateUrl: './glo-phonenumber-input.component.html',
  styleUrl: './glo-phonenumber-input.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class GloPhonenumberInputComponent implements ControlValueAccessor, Validator {
  @ViewChild('phoneInput', { read: ElementRef }) phoneInput!: ElementRef;

  @Input() label: string = '';
  @Input() name: string = 'phone';
  @Input() required: boolean = false;
  @Input() errorMessage: string = 'Please enter a valid phone number';
  @Input() customCssClass: string = 'form-control';

  // ngx-intl-tel-input specific inputs
  @Input() preferredCountries: CountryISO[] = [
    CountryISO.Pakistan,
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
    CountryISO.India
  ];
  @Input() enableAutoCountrySelect: boolean = true;
  @Input() enablePlaceholder: boolean = true;
  @Input() searchCountryFlag: boolean = true;
  @Input() searchCountryField: SearchCountryField[] = [SearchCountryField.All];
  @Input() selectFirstCountry: boolean = false;
  @Input() selectedCountryISO: CountryISO = CountryISO.Pakistan;
  @Input() maxLength: number = 15;
  @Input() phoneValidation: boolean = true;
  @Input() separateDialCode: boolean = true;
  @Input() numberFormat: PhoneNumberFormat = PhoneNumberFormat.International;


  // separateDialCode = false;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  // preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];


  value: any = null;
  touched: boolean = false;
  disabled: boolean = false;

  // ngAfterViewInit() {
  //   const inputEl = this.phoneInput.nativeElement.querySelector('input');
  //   if (inputEl) {
  //     inputEl.addEventListener('blur', () => {
  //       this.onInputTouched();
  //     });
  //   }
  // }

  private onChange: (value: any) => void = () => { };
  private onTouched: () => void = () => { };

  // ============================================
  // Computed Properties
  // ============================================

  get showError(): boolean {
    return this.required && !this.isValid();
  }

  phoneForm = new FormGroup({
    phone: new FormControl(undefined, [Validators.required])
  });
  validationChecker() {
    console.log("object", this.phoneForm.get('phone')?.invalid, this.phoneForm.get('phone')?.touched)
    return this.phoneForm.get('phone')?.invalid && this.phoneForm.get('phone')?.touched
  }
  // ============================================
  // Methods
  // ============================================

  onInputChange(value: any): void {

    this.value = value;
    console.log("object value", value, 'avlidation', value?.valid)
    this.onChange(value);
  }

  onInputTouched(): void {
    this.onTouched();
    this.touched = true;
  }

  isValid(): boolean {
    if (!this.value) {
      return !this.required;
    }
    // Check if phone object has valid international number
    return !!this.value?.internationalNumber;
  }

  // ============================================
  // ControlValueAccessor Implementation
  // ============================================

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = () => {
      this.touched = true;
      fn();
    };
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  // ============================================
  // Validator Implementation
  // ============================================

  validate(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return this.required ? { required: true } : null;
    }

    const phoneValue = control.value;

    // Check if it's a valid phone object with international number
    if (!phoneValue?.internationalNumber) {
      return { invalidPhone: { message: this.errorMessage } };
    }

    return null;
  }

}
